// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2E6U0","alertIcon":"ConfirmModal_alertIcon__1Nj7u"};